<!-- Study User List - Layout -->
<div class="container-fluid bg-white">
  <div class="row gx-0">
    <!-- Side Nav -->
    <div class="col-auto" style="margin-left: -1%;">
      <app-side-nav></app-side-nav>
    </div>

    <!-- Main Content -->
    <div class="col mt-2 px-3">
      <!-- Heading -->
      <div
        class="d-flex justify-content-between align-items-center flex-wrap py-3"
      >
        <h4 class="study-heading mb-0">
          <span class="text-muted fw-light">Study Management /</span> Study User
          List
        </h4>
      </div>

      <!-- Filters Row -->
      <div class="row filter-row g-2">
        <!-- Search by Name -->
        <div class="col-12 col-md-3">
          <input
            type="text"
            class="form-control filter-input"
            placeholder="Search by Name"
            [(ngModel)]="searchCrcName"
          />
        </div>

        <!-- Search by Study Name -->
        <div class="col-12 col-md-3">
          <input
            type="text"
            class="form-control filter-input"
            placeholder="Search by Study Name"
            [(ngModel)]="searchStudyName"
          />
        </div>

        <!-- Search by Location -->
        <div class="col-12 col-md-2">
          <input
            type="text"
            class="form-control filter-input"
            placeholder="Search Site Location"
            [(ngModel)]="searchLocation"
          />
        </div>

        <!-- Search by Assigned By -->
        <div class="col-12 col-md-2">
          <input
            type="text"
            class="form-control filter-input"
            placeholder="Search AssignedBy"
            [(ngModel)]="searchAssignedBy"
          />
        </div>

        <!-- Buttons -->
        <div
          class="col-12 col-md-2 d-flex justify-content-start gap-1"
        >
          <button class="btn custom-button" (click)="searchUsers()">
            Search
          </button>
          <button class="btn custom-button" (click)="clear()">Clear</button>
        </div>
      </div>

      <!-- Instruction -->
      <p class="instruction-text">
        Click on <strong>Study Name</strong> to view study details.
      </p>

      <!-- Spinner -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="height: 150px"
      >
        <div class="spinner-border text-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Table Card -->
      <div class="card" *ngIf="!loading">
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Id</th>
                <th>Assigned Users</th>
                <th>Study Name</th>
                <th>Site Location</th>
                <th>Template Name</th>
                <th>Date Assigned</th>
                <!--<th>completion date</th>-->
                <th>Assigned By</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="table-border-bottom-0">
              <tr *ngFor="let study of filteredData; let i = index">
                <td class="scrollable-cell">{{ study.id }}</td>

                <!-- Assigned Users -->
                <td class="scrollable-cell">
                  <div
                    class="assigned-users-container d-flex align-items-center"
                  >
                    <div
                      *ngIf="study.has_assignments"
                      class="users-circles-row d-flex flex-wrap align-items-center gap-1"
                    >
                      <div
                        *ngFor="let assignedUser of study.assigned_users"
                        class="user-circle d-inline-flex align-items-center justify-content-center"
                        (mouseenter)="showTooltip($event, assignedUser.name)"
                        (mouseleave)="hideTooltip()"
                      >
                        {{ assignedUser.initials }}
                      </div>
                    </div>
                    <div *ngIf="!study.has_assignments" class="no-assignments">
                      <span class="text-muted">No users assigned</span>
                    </div>
                  </div>
                </td>

                <!-- Study Name -->
                <td class="scrollable-cell">
                  <a class="hover-effect" (click)="openStudyDetail(study)">
                    {{ study.study_name }}
                  </a>
                  <span *ngIf="study.is_frozen" class="badge bg-info ms-2">❄️ Frozen</span>
                  <span *ngIf="study.is_locked" class="badge bg-warning ms-2">🔒 Locked</span>
                </td>

                <td class="scrollable-cell">{{ getSiteLocation(study) }}</td>
                <td class="scrollable-cell">{{ getTemplateName(study) }}</td>
                <td class="scrollable-cell">{{ study.start_date }}</td>
                <!--<td class="scrollable-cell">{{study.completion_date}}</td>-->
                <td class="scrollable-cell">{{ study.assigned_by }}</td>

                <!-- Actions -->
                <td>
                  <div class="dropdown" data-bs-display="static">
                    <button
                      type="button"
                      class="btn p-0 dropdown-toggle hide-arrow"
                      data-bs-toggle="dropdown"
                    >
                      <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-end custom-dropdown-menu"
                    >
                      <a
                        *ngIf="!study.has_assignments && !study.is_frozen && !study.is_locked"
                        class="dropdown-item"
                        href="javascript:void(0);"
                        (click)="openAssignCrcModal(study)"
                      >
                        <i class="bx bx-user-plus me-1"></i> Assign User's
                      </a>
                      <a
                        *ngIf="study.has_assignments && !study.is_frozen && !study.is_locked"
                        class="dropdown-item"
                        href="javascript:void(0);"
                        (click)="editCrcAssignments(study)"
                      >
                        <i class="bx bx-edit me-1"></i> Edit Assignments
                      </a>
                      <a
                        *ngIf="!study.is_locked && canManageFreezeLock()"
                        class="dropdown-item"
                        href="javascript:void(0);"
                        (click)="freezeStudy(study)"
                      >
                        <i class="bx bx-lock-open me-1" *ngIf="!study.is_frozen"></i>
                        <i class="bx bx-lock me-1" *ngIf="study.is_frozen"></i>
                        {{ study.is_frozen ? 'Unfreeze' : 'Freeze' }}
                      </a>
                      <a
                        *ngIf="!study.is_locked && canManageFreezeLock()"
                        class="dropdown-item"
                        [class.disabled]="study.is_locked"
                        href="javascript:void(0);"
                        (click)="!study.is_locked && lockStudy(study)"
                      >
                        <i class="bx bx-lock me-1"></i> Lock
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-center mt-4">
        <nav aria-label="Page navigation">
          <ul class="pagination mb-0 justify-content-center flex-wrap gap-1">
            <!-- Previous Button -->
            <li class="page-item mr-1" [class.disabled]="currentPage === 1">
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="prevPage()"
              >
                Previous
              </a>
            </li>

            <!-- Page Numbers -->
            <li
              *ngFor="let page of pageRange"
              class="page-item mr-1"
              [class.active]="page === currentPage"
            >
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <!-- Next Button -->
            <li class="page-item" [class.disabled]="currentPage === pages">
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="nextPage()"
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Overlay (if you are using it in layout) -->
<div class="layout-overlay layout-menu-toggle"></div>

<!-- Assign User Modal -->
<div
  class="modal fade"
  id="assignCrcModal"
  tabindex="-1"
  aria-labelledby="assignCrcModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="onAssignModalHidden()"
>
  <div class="modal-dialog">
    <div class="modal-content p-4" (click)="closeCustomDropdown()">
      <h5 class="modal-title mb-3">
        {{ isEditMode ? 'Manage User Assignments' : "Assign User's to Study" }}
      </h5>

      <!-- Study Name -->
      <div class="mb-3">
        <label for="studyName" class="form-label">Study Name</label>
        <input
          type="text"
          class="form-control"
          id="studyName"
          [value]="selectedStudy?.study_name"
          readonly
        />
      </div>

      <!-- Select Users -->
      <div class="mb-3 position-relative" (click)="$event.stopPropagation()">
        <label for="crcList" class="form-label">Select User's</label>

        <!-- Selected CRCs Display -->
        <div
          class="selected-crcs-container mb-2"
          *ngIf="assignCrcForm.get('selectedCrcs')?.value?.length > 0"
        >
          <div
            class="selected-crcs-row d-flex flex-wrap align-items-center gap-2"
          >
            <div
              *ngFor="
                let selectedCrc of assignCrcForm.get('selectedCrcs')?.value
              "
              class="crc-selected-item-circle d-inline-flex align-items-center justify-content-center"
              [title]="selectedCrc.item_text"
            >
              <div
                class="crc-selected-info d-flex flex-column align-items-center"
              >
                <div class="crc-selected-initials">
                  {{ selectedCrc.initials }}
                </div>
                <small class="crc-selected-designation">
                  {{ selectedCrc.designation }}
                </small>
              </div>
              <button
                type="button"
                class="crc-remove-btn"
                (click)="removeSelectedCrc(selectedCrc)"
                [attr.aria-label]="'Remove ' + selectedCrc.item_text"
                *ngIf="canRemoveCrc(selectedCrc)"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <!-- Custom dropdown trigger -->
        <div
          class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
          (click)="toggleCustomDropdown(); $event.stopPropagation()"
          [class.open]="showCustomDropdown"
        >
          <span class="dropdown-placeholder">
            {{
              assignCrcForm.get('selectedCrcs')?.value?.length > 0
                ? 'Add more users...'
                : "Select User's"
            }}
          </span>
          <i class="bx bx-chevron-down dropdown-arrow"></i>
        </div>

        <!-- Custom dropdown list -->
        <div class="custom-dropdown-list" *ngIf="showCustomDropdown" (click)="$event.stopPropagation()">
          <div class="dropdown-header">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search users..."
              [value]="searchTerm"
              (input)="searchTerm = $event.target.value; filterCrcs()"
              (click)="$event.stopPropagation()"
            />
          </div>
          <div class="dropdown-items">
            <div
              *ngFor="let crc of filteredCrcsList"
              class="dropdown-item-custom"
              [class.selected]="isCrcSelected(crc)"
              [class.disabled]="isEditMode && isCrcSelected(crc) && isCurrentUser(crc)"
              [style.pointer-events]="isEditMode && isCrcSelected(crc) && isCurrentUser(crc) ? 'none' : 'auto'"
              [style.opacity]="isEditMode && isCrcSelected(crc) && isCurrentUser(crc) ? '0.6' : '1'"
              (click)="toggleCrcSelection(crc); $event.stopPropagation()"
            >
              <div class="crc-item d-flex align-items-center">
                <div
                  class="crc-initials-circle me-2 d-inline-flex align-items-center justify-content-center"
                  [title]="crc.full_name"
                >
                  {{ crc.initials }}
                </div>
                <div class="crc-info flex-grow-1">
                  <div class="crc-name">{{ crc.full_name }}</div>
                  <small class="crc-designation text-muted">
                    {{ crc.designation }}
                  </small>
                </div>
                <i class="bx bx-check" *ngIf="isCrcSelected(crc)"></i>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="assignCrcValidationMessage" class="text-danger mt-1">
          {{ assignCrcValidationMessage }}
        </div>
      </div>

      <!-- Modal Actions -->
      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="assignCrcs()"
          [disabled]="!assignCrcForm.valid"
        >
          {{ isEditMode ? "Update User's" : "Assign User's" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Freeze/Unfreeze Study Modal -->
<div
  class="modal fade"
  id="freezeStudyModal"
  tabindex="-1"
  aria-labelledby="freezeStudyModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="closeFreezeModal()"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">
        {{ isFreezing ? 'Freeze Study' : 'Unfreeze Study' }}
      </h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Study:</strong> {{ currentStudy?.study_name }}
        </p>
        <div class="alert alert-info" *ngIf="isFreezing">
          <small>
            Freezing this study will make it view-only. No changes or edits will be allowed until it is unfrozen.
          </small>
        </div>
        <div class="alert alert-success" *ngIf="!isFreezing">
          <small>
            Unfreezing this study will restore all editing capabilities.
          </small>
        </div>
      </div>
      <div class="mb-3">
        <label for="freezeEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="freezeEmail"
          [(ngModel)]="freezeEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndFreeze()"
        />
      </div>
      <div class="mb-3">
        <label for="freezePassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showFreezePassword ? 'text' : 'password'"
            class="form-control"
            id="freezePassword"
            [(ngModel)]="freezePassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndFreeze()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleFreezePasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showFreezePassword" [class.bx-hide]="showFreezePassword"></i>
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label for="freezeReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="freezeReason"
          [(ngModel)]="freezeReason"
          rows="3"
          placeholder="Enter reason for {{ isFreezing ? 'freezing' : 'unfreezing' }} this study"
        ></textarea>
      </div>
      <div *ngIf="freezeError" class="text-danger mb-3">
        {{ freezeError }}
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="authenticateAndFreeze()"
          [disabled]="!freezeEmail || !freezePassword || !freezeReason"
        >
          {{ isFreezing ? 'Freeze' : 'Unfreeze' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Lock Study Modal -->
<div
  class="modal fade"
  id="lockStudyModal"
  tabindex="-1"
  aria-labelledby="lockStudyModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="closeLockModal()"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Lock Study</h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Study:</strong> {{ currentStudy?.study_name }}
        </p>
        <div class="alert alert-danger">
          <h6><strong>Warning:</strong></h6>
          <ul class="mb-0">
            <li>Once locked, this study <strong>CANNOT be unlocked.</strong></li>
            <li>You will <strong>NOT be able to make any changes</strong> to this study.</li>
            <li>This action is <strong>IRREVERSIBLE.</strong></li>
          </ul>
        </div>
      </div>
      <div class="mb-3">
        <label for="lockEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="lockEmail"
          [(ngModel)]="lockEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndLock()"
        />
      </div>
      <div class="mb-3">
        <label for="lockPassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showLockPassword ? 'text' : 'password'"
            class="form-control"
            id="lockPassword"
            [(ngModel)]="lockPassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndLock()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleLockPasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showLockPassword" [class.bx-hide]="showLockPassword"></i>
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label for="lockReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="lockReason"
          [(ngModel)]="lockReason"
          rows="3"
          placeholder="Enter reason for locking this study"
        ></textarea>
      </div>
      <div *ngIf="lockError" class="text-danger mb-3">
        {{ lockError }}
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn btn-danger"
          (click)="authenticateAndLock()"
          [disabled]="!lockEmail || !lockPassword || !lockReason"
        >
          Lock Study
        </button>
      </div>
    </div>
  </div>
</div>
